<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <v-btn
                class="mx-2"
                fab
                x-small
                color="primary"
                @click="$router.back()"
              >
                <v-icon dark> mdi-arrow-left </v-icon>
              </v-btn>
              <h3 class="font-weight-bold" v-text="'Store Gift'"></h3>
              <v-btn
                class="mx-2 mb-2"
                fab
                x-small
                color="primary"
                to="store-gifts/create"
              >
                <v-icon dark> mdi-plus </v-icon>
              </v-btn>
              <v-btn
                class="mx-2 mb-2"
                fab
                x-small
                color="primary"
                to="store-gifts/upload"
              >
                <v-icon dark> mdi-upload </v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search ... "
                    color="#e60040"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  >
                  </v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    rounded
                    v-model="filter.is_active"
                    :items="statuses"
                    clearable
                    @click:clear="(filter.is_active = null), (page = 1)"
                    label="Status"
                    @input="getData"
                    prepend-inner-icon="mdi-toggle-switch"
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        x-small
                        rounded
                        depressed
                        color="error"
                        class="my-auto"
                        @click="deleteAll(store_gifts.id)"
                        style="width: 90px; height: 50px"
                      >
                        <v-icon dark> mdi-delete </v-icon>
                      </v-btn>
                    </template>
                    <span>Delete all Store</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title v-if="store_gifts.length != 0">
              <v-spacer></v-spacer>
              <v-btn
                rounded
                large
                class="primary"
                @click="generateExcel()"
                v-if="isDeletePage() != true"
              >
                <span v-if="isExcelloading"> Generating Excel... </span>
                <span v-else>Generate Excel</span>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <section v-if="isLoading" style="height: 285px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                height="900"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>
                        <input
                          type="checkbox"
                          @change="selectAll()"
                          v-model="is_select_all"
                        />&nbsp; Sr. No.
                      </th>
                      <th class="text-left">Status</th>
                      <th class="text-left" style="min-width: none">Store</th>
                      <th class="text-left" style="min-width: none">
                        Store Location
                      </th>
                      <th class="text-left" style="min-width: none">
                        Store Code
                      </th>
                      <th class="text-left" style="min-width: 180px">Gift</th>
                      <th class="text-left" style="min-width: 120px">
                        Allotted Quantity
                      </th>
                      <th class="text-left" style="min-width: 120px">
                        Current Quantity
                      </th>
                      <th class="text-left" style="min-width: 140px">
                        Total Current Quantity
                      </th>
                      <th class="text-left" style="min-width: 120px">
                        Total Used Quantity
                      </th>
                      <th class="text-left" style="min-width: 120px">
                        Total Quantity
                      </th>
                      <th class="text-left" style="min-width: 120px">
                        Gifts Redeemed
                      </th>
                      <th class="text-right action_th">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="store_gifts.length != 0">
                    <tr
                      v-for="(store_gift, i) in store_gifts"
                      :key="`store_gift_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': store_gifts.length - 1 == i,
                      }"
                    >
                      <td>
                        <input
                          type="checkbox"
                          v-model="store_gift.is_selected"
                        />
                        &nbsp;{{ i + 1 }}
                      </td>
                      <td>
                        <v-tooltip bottom v-if="store_gift.is_active == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span> Store Gifts is Active</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="store_gift.is_active == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>Store Gifts is InActive</span>
                        </v-tooltip>
                      </td>
                      <td>
                        {{
                          store_gift.store ? store_gift.store.business_name : ""
                        }}
                      </td>
                      <td>
                        {{
                          store_gift.store
                            ? store_gift.store.store_location
                            : ""
                        }}
                      </td>
                      <td>
                        {{
                          store_gift.store ? store_gift.store.store_code : ""
                        }}
                      </td>
                      <td>
                        {{ store_gift.gift ? store_gift.gift.name : "N/A" }}
                      </td>
                      <td>{{ store_gift.alloted_quantity || "0" }}</td>
                      <td>{{ store_gift.current_quantity || "0" }}</td>
                      <td>{{ store_gift.total_current_quantity || "0" }}</td>
                      <td>{{ store_gift.used_stock_quantity || "0" }}</td>
                      <td>
                        <span class="font-weight-medium">
                          {{ store_gift.total_quantity || "0" }}
                        </span>
                      </td>
                      <td>{{ store_gift.redemption_count || "0" }}</td>
                      <td class="text-right">
                        <div class="d-flex align-center justify-end">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="mr-2"
                                fab
                                x-small
                                color="primary"
                                :to="`/store-gifts/${encryptIt(
                                  store_gift.id
                                )}/gift-stocks`"
                              >
                                <v-icon dark> mdi-plus </v-icon>
                              </v-btn>
                            </template>
                            <span>Add New Gift Stocks</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="mr-2"
                                fab
                                x-small
                                color="info"
                                @click="refreshIndividualGift(store_gift.id)"
                              >
                                <v-icon dark> mdi-refresh </v-icon>
                              </v-btn>
                            </template>
                            <span>Refresh Gift</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                color="error"
                                @click="Delete_this(store_gift.id)"
                              >
                                <v-icon dark> mdi-delete </v-icon>
                              </v-btn>
                            </template>
                            <span>Delete this Store Gifts</span>
                          </v-tooltip>
                        </div>
                        <v-dialog v-model="is_deleted_store_gift" width="600">
                          <v-card rounded="xxl">
                            <v-container>
                              <v-row align="center">
                                <v-col sm="3" align="center">
                                  <v-icon
                                    large
                                    color="error"
                                    style="
                                      font-size: 90px;
                                      width: 200px !important;
                                    "
                                  >
                                    mdi-delete-empty
                                  </v-icon>
                                </v-col>
                                <v-col sm="9" align="center">
                                  <v-card-text>
                                    <v-row>
                                      <v-col>
                                        <h1 style="color: red">Delete!</h1>
                                        <br />
                                        <h3>
                                          Are you sure, you want to delete ?.
                                        </h3>
                                        <br />

                                        <v-btn
                                          class="mr-10"
                                          color="success"
                                          @click="confirmDelete"
                                        >
                                          Yes
                                        </v-btn>
                                        <v-btn
                                          class="ml-10"
                                          color="error"
                                          @click="is_deleted_store_gift = false"
                                        >
                                          Cancel
                                        </v-btn>
                                      </v-col>
                                    </v-row>
                                  </v-card-text>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-card>
                        </v-dialog>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="13" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination rounded v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_deleted_store_gift" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Store Gift deleted successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_deleted_store_gift = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "StoreGiftsPage",
  data() {
    return {
      filter: {
        search_keyword: "",
        is_active: "",
        is_selected: false,
      },
      store_gifts: [],
      statuses: [
        {
          id: 0,
          text: "Select Active Status",
          value: "",
        },
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      isLoading: false,
      isExcelloading: false,
      delete_store_gift: false,
      is_deleted_store_gift: false,
      is_select_all: false,
      isDeleteAll: false,
      deleteId: null,
    };
  },
  watch: {
    page: "getData",
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      this.filter.store_id = this.decryptIt(this.$route.params.storeId);
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&is_active=" +
        this.filter.is_active +
        "&store_id=" +
        this.filter.store_id +
        "&search_keyword=" +
        this.filter.search_keyword;
      await axios
        .get(`store_gifts?${query}`)
        .then((response) => {
          this.store_gifts = response.data.data;
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
      this.isLoading = false;
    },
    selectAll() {
      console.log(this.is_select_all);
      this.store_gifts.forEach((store_gift) => {
        store_gift.is_selected = this.is_select_all;
      });
    },
    async deleteAll() {
      this.isDeleteAll = true;
      let deleteallIds = [];
      this.store_gifts.forEach((store_gift) => {
        if (store_gift.is_selected) deleteallIds.push(store_gift);
      });
      await axios
        .post("/store_gifts/alldelete", { deleteallIds })
        .then(() => {
          this.filter.status = "";
          this.getData();
        })
        .catch(function (error) {
          this.getData();
          console.log(error);
        });
      // let response = await axios.post(/sync_users/update_date_all, this.form);
      this.isDeleteAll = false;
    },
    async Delete_this(id) {
      this.deleteId = id; // Store the id of the item to delete
      this.is_deleted_store_gift = true; // Show the confirmation dialog
    },
    async confirmDelete() {
      this.is_deleted_store_gift = true;
      await axios
        .post(`/store_gifts/delete/${this.encryptIt(this.deleteId)}`)
        .then(() => {
          this.is_deleted_store_gift = true;
          this.getData();
          this.is_deleted_store_gift = false;
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
    },
    //Refresh Individual Gift
    async refreshIndividualGift(storeGiftId) {
      // Validate input
      if (!storeGiftId) {
        this.$toast.error("Invalid store gift ID");
        return;
      }

      try {
        const response = await axios.post(`/store_gifts/refresh_individual_gift`, {
          store_gift_id: storeGiftId
        });
        
        // Handle successful response
        if (response && response.data && response.data.success === true) {
          this.getData();
          this.$toast.success(response.data.message || "Gift refreshed successfully");
        } else if (response && response.data && response.data.success === false) {
          // Handle unsuccessful response (success: false)
          const message = response.data.message || response.data.error || "Failed to refresh gift";
          this.$toast.error(message);
        } else {
          this.$toast.error("Invalid response from server");
        }
      } catch (error) {
        console.log("Refresh Individual Gift Error:", error);
        
        let errorMessage = "Failed to refresh gift";
        
        // Check if error has response from server
        if (error && error.response) {
          const errorResponse = error.response;
          
          // Try to extract error message from response data
          if (errorResponse.data) {
            const errorData = errorResponse.data;
            
            // Check for message field first
            if (errorData.message) {
              errorMessage = errorData.message;
            }
            // Check for error field
            else if (errorData.error) {
              errorMessage = errorData.error;
            }
            // Check for Laravel validation errors
            else if (errorData.errors) {
              if (typeof errorData.errors === 'object' && errorData.errors !== null) {
                try {
                  const errorMessages = Object.values(errorData.errors).flat();
                  errorMessage = errorMessages.join(', ');
                } catch (e) {
                  errorMessage = "Validation error occurred";
                }
              } else if (Array.isArray(errorData.errors)) {
                errorMessage = errorData.errors.join(', ');
              } else {
                errorMessage = String(errorData.errors);
              }
            }
            // If errorData is a string
            else if (typeof errorData === 'string') {
              errorMessage = errorData;
            }
          }
          
          // Fallback to status-based messages
          if (errorMessage === "Failed to refresh gift") {
            if (errorResponse.status === 400) {
              errorMessage = "Bad Request - Please check the data and try again";
            } else if (errorResponse.status === 404) {
              errorMessage = "Store gift not found";
            } else if (errorResponse.status === 422) {
              errorMessage = "Validation Error - Please check your input";
            } else if (errorResponse.status === 500) {
              errorMessage = "Server Error - Please try again later";
            } else {
              errorMessage = `Error ${errorResponse.status}: ${errorResponse.statusText || 'Unknown error'}`;
            }
          }
        }
        // Network or other errors
        else if (error && error.request) {
          errorMessage = "Network error - Please check your connection";
        }
        // Other errors (like axios configuration issues)
        else if (error && error.message && !error.message.includes('Object.keys')) {
          errorMessage = error.message;
        }

        this.$toast.error(errorMessage);
      }
    },
    //Generate Excel
    async generateExcel() {
      this.isExcelLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      this.filter.store_id = this.decryptIt(this.$route.params.storeId);
      let response = [];
      let query =
        "&role_id=2" +
        "&companyId=" +
        this.company.id +
        "&store_id=" +
        this.filter.store_id +
        "&is_active=" +
        this.filter.is_active +
        "&search_keyword=" +
        this.filter.search_keyword;
      response = await axios
        .get(`/store_gifts/excel_export?${query}`)
        .then((response) => window.open(`${response.data.data}`, "_blank"));
      if (response) {
        console.log(response);
      }
      this.isExcelloading = false;
    },
  },
};
</script>
